{
  "settingsPresenter": {
    "title": "Paramètres – {{fboName}}",
    "newHangarName": "Nouveau hangar",
    "buttons": {
      "addHangar": "Ajouter hangar"
    },
    "tabs": {
      "hangars": "Hangars",
      "ramps": "Tarmacs",
      "stackingSOPs": "Empilage des SOPs",
      "towingEquipment": "Équipement de remorquage",
      "estimation": "Estimation",
      "opsCenter": "Centre Ops",
      "teamMembers": "Membres équipe",
      "configuration": "Configuration",
      "reports": "Rapports",
      "integrations": "Intégrations",
      "account": "Compte"
    }
  },
  "rampsSettings": {
    "rampEditor": {
      "properties": "Propriétés",
      "rampVersion": "Version du tarmac",
      "v2Algorithm": "Algorithme V2",
      "toolbar": {
        "selectSpotSize": "Sélectionner la taille de place"
      }
    }
  }
}
